<div class="mat-dialog-wrapper">
  <div class="d-flex justify-space-between align-items-center mb-1">
<h2 mat-dialog-title class="m-0">{{ type ? (type.charAt(0).toUpperCase() + type?.slice(1)) : ''}} Disclosures</h2>
<button
      mat-button
      class="header-text-close d-flex align-items-center"
      disableRipple
      mat-dialog-close
>
<mat-icon>close</mat-icon>
</button>
</div>
  
  <mat-dialog-content>
    <div class="sidenav-body">
      <div class="d-flex gap-20">
        <div class="form-field w-520">
          <p class="fw-bold">Title<span class="text-danger-300">*</span></p>
          <mat-form-field appearance="fill" class="w-350">
            <input
              [value]="title"
              type="text"
              matInput
              maxlength="255"
              autocomplete="off"
              required
              [(ngModel)]="title"
              
            />
          </mat-form-field>
        </div>
      </div>
      <div class="form-field textarea">
        <p class="fw-bold">Note Contents<span class="text-danger-300">*</span></p>
        <ejs-richtexteditor
          [(ngModel)]="content"
          [toolbarSettings]="commonService.syncfusionRichTextEditorToolbarSettings"
          (actionBegin)="commonService.syncfusionRichTextEditorOnActionBegin($event)"
          [enableXhtml]="true"
          [toolbarSettings]="commonService.syncfusionRichTextEditorTools"
          [enableHtmlSanitizer]="true"
          [pasteCleanupSettings]="commonService.syncfusionRichTextEditorPasteCleanupSettings"
        ></ejs-richtexteditor>
      </div>
    </div>
  </mat-dialog-content>

    <div class="d-flex pb-5 pt-10 hr-top pt-1 mt-5">
      <button
        class="action-button primary-button mr-1"
        type="button"
        mat-button
        disableRipple
        (click)="onSave()"
      >
        Save
      </button>
      <button
        class="action-button secondary-button"
        mat-dialog-close
        disableRipple
        type="button"
        mat-button
        disableRipple
        (click)="onCancel(false)"
      >
        Cancel
      </button>
    </div>
</div>

<app-custom-notifications></app-custom-notifications>
